import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { UserContact } from "./contact";

export const RecaptchaProvider = () => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6Ldi_YEsAAAAAAPn753-698rqVf9ZkBlt7AFlmyE">
            <UserContact />
        </GoogleReCaptchaProvider>
    );
};
